"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = _interopRequireDefault(require("lodash"));
var _index = require("./index");
var _cookie = require("@/utils/cookie");
var _permission = _interopRequireDefault(require("@/utils/permission"));
var _ga = require("@/utils/ga");
var _log = require("@/utils/log");
var _hikeAdvancedReport = require("@/api/hike-advanced-report");
var _lifehikesInitData = require("@/lifehikes-init-data");
var _vuex = require("vuex");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'HikeAdvReportMain',
  components: {
    HikeAdvReportAdvancedReport: _index.HikeAdvReportAdvancedReport,
    HikeAdvReportInfo: _index.HikeAdvReportInfo
  },
  props: {
    displayType: {
      type: String,
      default: 'create'
    }
  },
  data() {
    return {
      fullscreenloading: false,
      recordStatus: '',
      hikeAdvReportForm: {
        id: '',
        title: '',
        publish: '',
        start: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        end: {
          utc: '',
          timezone: _momentTimezone.default.tz.guess(),
          local: ''
        },
        // locale: 'en',  no use
        description: '',
        reports: [],
        tempInternalTitle: '',
        internal: {
          title: '',
          opportunityNumber: '',
          clientName: '',
          remark: ''
        },
        password: '',
        overallSkillSummary: true,
        individualBreakdown: true,
        individualReport: true,
        showStageAttendance: true,
        showParticipantRate: true,
        groupHighlights: true,
        showNegativeGrowth: false,
        mostActiveHikersMaxCount: 3,
        mostImprovedHikersMaxCount: 3,
        participantFeedback: true,
        showSkillCompass: true,
        showPiExplanation: true,
        metadata: {
          tenant: ''
        }
      }
    };
  },
  computed: {
    ...(0, _vuex.mapGetters)(['email'])
  },
  created() {
    if (this.displayType === 'edit') {
      const id = typeof this.$route.params.id === 'undefined' ? this.hikeAdvReportForm.id : this.$route.params.id;
      this.recordStatus = 'edit';
      this.fromId = typeof this.$route.query.fromId === 'undefined' ? '' : this.$route.query.fromId;
      this.getHikeAdvReport(id); // copy mode is false
    } else {
      // create from new
      this.recordStatus = 'create';
    }
  },
  methods: {
    async doCreate(publishStatus) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      this.hikeAdvReportForm.publish = publishStatus;
      this.hikeAdvReportForm.internal.title = this.hikeAdvReportForm.tempInternalTitle;

      // validate
      if (!this.hikeAdvReportForm.metadata || this.hikeAdvReportForm.metadata.tenant === '') {
        this.fullscreenloading = false;
        const msg = 'Please select the tenant';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.hikeAdvReportForm.title === '') {
        this.fullscreenloading = false;
        const msg = 'Title is missing';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.hikeAdvReportForm.start.utc === '' || this.hikeAdvReportForm.end.utc === '') {
        this.fullscreenloading = false;
        const msg = `Report availability period is missing`;
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      const startDate = new Date(this.hikeAdvReportForm.start.utc);
      const endDate = new Date(this.hikeAdvReportForm.end.utc);
      if (startDate > endDate) {
        this.fullscreenloading = false;
        const msg = 'Start-Time is later than End-Time in Availability period';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.hikeAdvReportForm.start.timezone === '' || this.hikeAdvReportForm.end.timezone === '') {
        this.fullscreenloading = false;
        const msg = 'Timezone is missing';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }

      // submit
      if (this.hikeAdvReportForm.id === '') {
        (0, _hikeAdvancedReport.createAdvancedReport)(token, this.hikeAdvReportForm).then(response => {
          (0, _log.showDebugLog)('Hike-create-response1', response);
          this.fullscreenloading = false;
          this.hikeAdvReportForm.id = response.data.id;
          this.hikeAdvReportForm.publish = response.data.publish;

          // console.log('Success create', this.displayType)
          const msg = `${response.data.title} (${response.data.id}) is created.`;
          (0, _log.displayPopupMessage)(msg, 'success');
          (0, _ga.writeGaEvent)(this, 'HikeAdvancedReport', `${_lifehikesInitData.userEvent.hikeAdvancedReport.create}`, oEmail, `Hike Id: ${this.hikeAdvReportForm.id}`);
          if (this.displayType === 'create') {
            this.$router.push(`/hike-advanced-report/edit/${response.data.id}`);
          }
        }).catch(error => {
          (0, _log.showDebugLog)('hike-create-error', error);
          this.fullscreenloading = false;
          (0, _log.displayPopupMessage)(error, 'error');
        });
      }
    },
    async doSave(publishStatus) {
      this.fullscreenloading = true;
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      const oEmail = (0, _cookie.getCookie)('EMAIL');
      const id = typeof this.$route.params.id === 'undefined' ? this.hikeAdvReportForm.id : this.$route.params.id;
      this.hikeAdvReportForm.publish = publishStatus;
      this.hikeAdvReportForm.internal.title = this.hikeAdvReportForm.tempInternalTitle + '';

      // validate
      if (!this.hikeAdvReportForm.metadata || this.hikeAdvReportForm.metadata.tenant === '') {
        this.fullscreenloading = false;
        const msg = 'Please select the tenant';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.hikeAdvReportForm.title === '') {
        this.fullscreenloading = false;
        const msg = `Title is missing`;
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      if (this.hikeAdvReportForm.start.utc === '' || this.hikeAdvReportForm.end.utc === '') {
        this.fullscreenloading = false;
        const msg = `Report availability period is missing`;
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      const startDate = new Date(this.hikeAdvReportForm.start.utc);
      const endDate = new Date(this.hikeAdvReportForm.end.utc);
      if (startDate > endDate) {
        this.fullscreenloading = false;
        const msg = 'Start-Time is later than End-Time in Availability period';
        (0, _log.displayPopupMessage)(msg, 'error');
        return;
      }
      // submit
      (0, _log.showDebugLog)('Save Form', this.hikeAdvReportForm);
      (0, _hikeAdvancedReport.updateAdvancedReport)(token, id, this.hikeAdvReportForm).then(response => {
        (0, _log.showDebugLog)('Hike-update-response', response);
        this.fullscreenloading = false;
        this.hikeAdvReportForm.id = response.data.id;
        this.hikeAdvReportForm.publish = response.data.publish;
        const msg = `${response.data.title} (${response.data.id}) is updated.`;
        (0, _log.displayPopupMessage)(msg, 'success');
        (0, _ga.writeGaEvent)(this, 'HikeAdvancedReport', `${_lifehikesInitData.userEvent.hikeAdvancedReport.edit}`, oEmail, `Edit in Hike Advanced Report Main - Hike Advanced Report Id: ${this.hikeAdvReportForm.id}`);
      }).catch(error => {
        (0, _log.showDebugLog)('Hike-update-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });

      // this.flagRemindSave = (this.hikeAdvReportForm.stages[0].taskSortDay)? false : true
    },
    getHikeAdvReport(id) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.fullscreenloading = true;
      (0, _hikeAdvancedReport.getAdvancedReportById)(token, id).then(response => {
        const d = response.data;
        // check error and return immediate
        if (typeof d.id === 'undefined') {
          this.fullscreenloading = false;
          const msg = 'Cannot get the hike, please contact to system administrator';
          (0, _log.displayPopupMessage)(msg, 'error');
          return;
        }
        this.hikeAdvReportForm.id = d.id;
        this.hikeAdvReportForm.reports = d.reports;
        this.hikeAdvReportForm.password = typeof d.password === 'undefined' ? '' : d.password;
        this.hikeAdvReportForm.overallSkillSummary = typeof d.overallSkillSummary === 'undefined' ? true : d.overallSkillSummary;
        this.hikeAdvReportForm.individualBreakdown = typeof d.individualBreakdown === 'undefined' ? true : d.individualBreakdown;
        this.hikeAdvReportForm.individualReport = typeof d.individualReport === 'undefined' ? true : d.individualReport;
        this.hikeAdvReportForm.groupHighlights = typeof d.groupHighlights === 'undefined' ? true : d.groupHighlights;
        this.hikeAdvReportForm.showNegativeGrowth = typeof d.showNegativeGrowth === 'undefined' ? false : d.showNegativeGrowth;
        this.hikeAdvReportForm.mostActiveHikersMaxCount = typeof d.mostActiveHikersMaxCount === 'undefined' ? 3 : d.mostActiveHikersMaxCount;
        this.hikeAdvReportForm.mostImprovedHikersMaxCount = typeof d.mostImprovedHikersMaxCount === 'undefined' ? 3 : d.mostImprovedHikersMaxCount;
        this.hikeAdvReportForm.showStageAttendance = typeof d.showStageAttendance === 'undefined' ? true : d.showStageAttendance;
        this.hikeAdvReportForm.showParticipantRate = typeof d.showParticipantRate === 'undefined' ? true : d.showParticipantRate;
        this.hikeAdvReportForm.participantFeedback = typeof d.participantFeedback === 'undefined' ? true : d.participantFeedback;
        this.hikeAdvReportForm.showSkillCompass = typeof d.showSkillCompass === 'undefined' ? true : d.showSkillCompass;
        this.hikeAdvReportForm.showPiExplanation = typeof d.showPiExplanation === 'undefined' ? true : d.showPiExplanation;
        this.hikeAdvReportForm.title = typeof d.title === 'undefined' ? '' : d.title;
        this.hikeAdvReportForm.internal.title = typeof d.title === 'undefined' ? '' : d.internal.title;
        this.hikeAdvReportForm.description = typeof d.description === 'undefined' ? '' : d.description;
        this.hikeAdvReportForm.internal.opportunityNumber = typeof d.internal === 'undefined' ? '' : d.internal.opportunityNumber;
        this.hikeAdvReportForm.publish = typeof d.publish === 'undefined' ? '' : d.publish;
        // start date
        if (typeof d.start === 'undefined') {
          this.hikeAdvReportForm.start = {
            utc: '',
            timezone: _momentTimezone.default.tz.guess(),
            local: ''
          };
        } else {
          this.hikeAdvReportForm.start.utc = typeof d.start.utc === 'undefined' ? '' : d.start.utc;
          this.hikeAdvReportForm.start.local = typeof d.start.local === 'undefined' ? '' : d.start.local; // moment(d.start.local).tz(moment.tz.guess()).toString()
          this.hikeAdvReportForm.start.timezone = typeof d.start.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.start.timezone;
        }

        // end date
        if (typeof d.end === 'undefined') {
          this.hikeAdvReportForm.end = {
            utc: '',
            timezone: _momentTimezone.default.tz.guess(),
            local: ''
          };
        } else {
          this.hikeAdvReportForm.end.utc = typeof d.end.utc === 'undefined' ? '' : d.end.utc; // d.end.utc.toISOString()
          this.hikeAdvReportForm.end.local = typeof d.end.local === 'undefined' ? '' : d.end.local; // moment(d.start.end).tz(moment.tz.guess()).toString() // d.end.local // d.end.utc.toISOString()
          this.hikeAdvReportForm.end.timezone = typeof d.end.timezone === 'undefined' ? _momentTimezone.default.tz.guess() : d.end.timezone;
        }

        // metadata
        this.hikeAdvReportForm.metadata = typeof d.metadata === 'undefined' ? {
          tenant: ''
        } : d.metadata;

        // To Solve internal title lagging issue, use other variable name to replace.
        this.hikeAdvReportForm.tempInternalTitle = this.hikeAdvReportForm.internal.title + '';
        this.fullscreenloading = false;
      }).catch(error => {
        (0, _log.showDebugLog)('hike-getHikeById-error', error);
        this.fullscreenloading = false;
        (0, _log.displayPopupMessage)(error, 'error');
      });
    },
    updateParentReportInfo(info) {
      // console.log('updateParentReportInfo:')
      // console.log(info)
    },
    updateParentReports(reports) {
      this.$set(this.hikeAdvReportForm, 'reports', reports);
    },
    handleClick() {
      // do something later
      // auto save when change tab
    },
    checkArrayLength(obj) {
      if (Array.isArray(obj)) {
        return obj.length;
      } else {
        return 0;
      }
    }
  }
};